import _ from 'lodash';

export function toPx(value: number | string, precision?: number): string;
export function toPx(value: undefined, precision?: number): undefined;
export function toPx(value: number | string | undefined, precision = 0): string | undefined {
  if (_.isNil(value)) {
    return value;
  }

  return `${_.round(parseFloat(String(value)), precision)}px`;
}

// 16px => 16
// 16 => 16
// 2rem => NaN
export function fromPx(value: string): number {
  const mathes = /^([\d.]+)(px)?$/.exec(value);
  if (!mathes) {
    return NaN;
  }

  return parseFloat(mathes[1]);
}
